import React from "react";

export default class LoadingFeedback extends React.Component {
  render() {
    return (
      <div className="loading-feedback">
        <h3>{this.props.feedback}</h3>
      </div>
    );
  }
}
